import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
// import Template1 from './Template1';
// import Template2 from './Template2';
// import Template3 from './Template3';
// import Template4 from './Template4';
// import Template5 from './Template5';
// import { templateArray } from '../Constants';

import { T } from '../Utils';
import Cards from './Cards/Cards';
import {
	ArrowLeft,
	ArrowRight,
	BackwardCarousel,
	ForwardCarousel,
} from '../../Buttons/IconButton/Icons';
import Button from '../../Buttons/Button/Button';
import { returnSaneURL } from '../../../../Utils/getImg';
import { TString } from '../Utils';
import Axios from 'axios';
import { loadStateSession } from '../../../FlyfishComponents/flyfishutils/utils';

interface Props {
	data: any;
	isMultiChoice?: boolean;
	shouldDisableActions?: boolean;
	handleSubmit?: Function;
	isMultiSelect?: boolean;
	isInsideCampaign: boolean;
	botImageCheck: boolean;
	index: number;
	logoImagePath?: string;
	voiceResponse?: boolean;
	langCode?: string;
	lengthArray: number;
	flyFishChangesReq?: boolean;
	addUserResponse?: Function;
	getProductDetails?: Function;
	tenantId?: string;
	token?: string;
}
// const templateMapping = {
//   1: Template1,
//   2: Template2,
//   3: Template3,
//   4: Template4,
//   5: Template5
// };
// template mapping may be used in future.
const SFCarousel = (props: Props) => {
	const {
		data,
		isMultiChoice,
		shouldDisableActions,
		handleSubmit,
		isMultiSelect,
		isInsideCampaign,
		botImageCheck,
		index,
		logoImagePath,
		voiceResponse,
		langCode,
		lengthArray,
		addUserResponse,
		getProductDetails,
		tenantId,
		token,
	} = props;
	const [selectionArray, setSelectionArray] = React.useState([]);
	const [selectedItem, setSelectedItem] = React.useState(0);
	const [selectedIndicator, setSelectedIndicator] = React.useState(0);
	const [llmproducts, setLLMProducts] = React.useState([]);

	React.useEffect(() => {
		if (
			selectionArray.length === 0 &&
			data.lists &&
			data.lists.items.length > 0
		) {
			setSelectionArray(data.lists.items.map((e) => e.selectedFlag === '1'));
		}
	}, [selectionArray]);
	const toggleInput = (list) => {
		document.getElementById('sfChatInputMain').style.visibility =
			data.lists.items.filter((_, index) => list[index]).length !== 0
				? 'hidden'
				: 'visible';
	};
	const handleSelection = (index) => {
		let __selectionArray = [...selectionArray];
		__selectionArray[index] = !__selectionArray[index];
		setSelectionArray(__selectionArray);
		toggleInput(__selectionArray);
	};
	const handleConfirm = () => {
		const selectedElements = data.lists.items.filter(
			(e, index) => selectionArray[index]
		);
		if (selectedElements.length === 0) return;
		const itemsToSend = selectedElements.map((e) => e.title).join(', ');
		toggleInput([]);
		handleSubmit(itemsToSend);
	};
	const cancelSelections = () => {
		setSelectionArray(data.lists.items.map((e) => false));
		toggleInput([]);
	};
	let cardLayout =
		data.lists && data.lists.items.length > 0
			? data.lists.items[0].cardLayout || 0
			: 0;

	// const templateType = templateArray[cardLayout].type;
	// const order = templateArray[cardLayout].order;
	// const Template = templateMapping[templateType];
	React.useEffect(() => {
		let productIdsArray = props.data.lists.items.map((eachItem, index) => {
			return eachItem.productId;
		});
		let stringifyProductIDs = String(productIdsArray);
		stringifyProductIDs &&
			Axios.get(
				`${
					window['BASE_URL']
				}/shop/${tenantId}/products/price?productIds=${stringifyProductIDs}&country=${loadStateSession(
					'FS-countryCode'
				)}`,
				{
					headers: {
						'x-tenant-id': tenantId,
						Authorization: `Bearer ${token}`,
					},
				}
			).then((resp: any) => {
				let response = resp.data.response;
				let products = response.data.products;
				setLLMProducts(products);
			});
	}, []);
	React.useEffect(() => {}, [llmproducts]);

	const productContent = (eachCard, index) => {
		let price = llmproducts.length
			? llmproducts.filter(
					(v) => v.id === (eachCard.productId || eachCard.product_id)
			  )[0].price
			: '';
		let currency =
			llmproducts.length &&
			llmproducts.filter(
				(v) => v.id === (eachCard.productId || eachCard.product_id)
			)[0].currency;

		return (
			<>
				<Cards
					key={eachCard.title}
					{...eachCard}
					price={price}
					currency={currency}
					onClick={() => {
						if (eachCard.productId || eachCard.product_id) {
							getProductDetails(
								eachCard.productId || eachCard.product_id,
								eachCard.title
							);
						} else if (isMultiChoice) {
							if (eachCard.productId || eachCard.product_id) {
								getProductDetails(
									eachCard.product_id || eachCard.productId,
									eachCard.title
								);
							} else eachCard.title && handleSubmit(eachCard.title);
						} else if (isMultiSelect) {
							handleSelection(index);
							setSelectedItem(index);
						}
					}}
					selected={selectionArray[index]}
					isMultiChoice={isMultiChoice}
					isMultiSelect={isMultiSelect}
					disabled={shouldDisableActions}
					miniCards={['0', '5', '9'].includes(cardLayout)}
					onlyImage={cardLayout === '8'}
					voiceResponse={voiceResponse}
					langCode={langCode}
				/>
			</>
		);
	};

	return (
		<>
			{botImageCheck && index == 0 ? (
				<div className={'preview-image-holder'}>
					<img
						src={returnSaneURL(logoImagePath)}
						alt={TString({ labelName: 'botAvatarLabel' })}
					/>
				</div>
			) : null}
			{data.displayResponse ? (
				<div
					tabIndex={voiceResponse || shouldDisableActions ? -1 : 0}
					className={`list-carousel-message`}
					// ${props.index == lengthArray && props.index == 0
					//     ? ''
					//     : props.index == 0
					//     ? 'first-curve'
					//     : props.index == lengthArray
					//     ? 'last-curve'
					//     : 'no-curve'
					// }
					dangerouslySetInnerHTML={{
						__html: data.displayResponse,
					}}
				/>
			) : null}
			{props.data.lists && props.data.lists.items.length > 0 ? (
				<>
					<div
						tabIndex={voiceResponse || shouldDisableActions ? -1 : 0}
						className={`sfchatbot-carousel-wrapper ${
							selectedIndicator !== 0 ? 'shadow-left' : ''
						} ${
							selectedIndicator !== props.data.lists.items.length - 1
								? 'shadow-right'
								: ''
						}`}
						style={{ marginTop: '20px' }}
					>
						<Carousel
							showArrows={true}
							showStatus={false}
							showThumbs={false}
							showIndicators={true}
							selectedItem={selectedItem}
							centerMode
							centerSlidePercentage={
								(window.innerWidth < 800 && window.innerWidth > 450) ||
								(window.screen.width < 800 && window.screen.width > 450) ||
								(isInsideCampaign &&
									window.innerWidth > 450 &&
									window.screen.width > 450)
									? 50
									: 80
							}
							width={'100%'}
							renderArrowNext={(onClickHandler, hasNext) =>
								hasNext && (
									<button
										className={`carouselButtons clickable right `}
										onClick={onClickHandler}
										title={TString({
											labelName: 'nextLabel',
											langCode: langCode,
											fromClass: true,
										})}
										style={{
											top: '90px',
											right: selectedIndicator === 0 ? '4px' : '18px',
										}}
									>
										{/* <ArrowRight /> */}
										<ForwardCarousel />
									</button>
								)
							}
							renderArrowPrev={(onClickHandler, hasPrev) =>
								hasPrev && (
									<button
										className={`carouselButtons clickable left `}
										onClick={onClickHandler}
										title={TString({
											labelName: 'previousLabel',
											langCode: langCode,
											fromClass: true,
										})}
										style={{
											top: '90px',
											left:
												selectedIndicator <= props.data.lists.items.length - 1
													? '18px'
													: '20px',
										}}
									>
										{/* <ArrowLeft /> */}
										<BackwardCarousel />
									</button>
								)
							}
							renderIndicator={(onClickHandler, isSelected, index) => {
								if (isSelected) {
									setSelectedIndicator(index);
								}

								return (
									props.data.lists &&
									props.data.lists.items.length > 1 && (
										<InViewIndicator
											onClickHandler={onClickHandler}
											isSelected={isSelected}
											index={index}
											label={TString({
												labelName: 'cardLabel',
												langCode: langCode,
												fromClass: true,
											})}
											data={props.data}
											selectedIndicator={selectedIndicator}
										/>
									)
								);
							}}
						>
							{props.data.lists.items.length > 0 &&
								props.data.lists.items.map((eachCard, index) => {
									return productContent(eachCard, index);
								})}
						</Carousel>
					</div>
					{isMultiSelect &&
					!shouldDisableActions &&
					data.lists.items.filter((_, index) => selectionArray[index])
						.length !== 0 ? (
						<div className='list-carousel-submit'>
							<Button
								label={<T labelName='submitLabel' />}
								onClick={handleConfirm}
							/>
							<Button
								label={<T labelName='cancelLabel' />}
								onClick={() => {
									cancelSelections();
								}}
							/>
						</div>
					) : null}
				</>
			) : null}
		</>
	);
};

function InViewIndicator(props: {
	onClickHandler;
	index;
	label?;
	isSelected;
	data;
	selectedIndicator;
}) {
	return (
		<li
			className={`carousel-indicator clickable ${
				props.isSelected ? 'selected' : ''
			} ${
				props.selectedIndicator - 4 >= 0 &&
				props.selectedIndicator + 3 <= props.data.lists.items.length - 1
					? props.index >= props.selectedIndicator - 4 &&
					  props.index <= props.selectedIndicator + 3
						? ''
						: 'hide'
					: (props.selectedIndicator - 4 < 0 && props.index < 8) ||
					  (props.selectedIndicator + 3 >= props.data.lists.items.length - 1 &&
							props.index >= props.data.lists.items.length - 8)
					? ''
					: 'hide'
			}
        `}
			onClick={props.onClickHandler}
			onKeyDown={props.onClickHandler}
			value={props.index}
			key={props.index}
			role='button'
			// tabIndex={0}
			title={`${props.label} ${props.index + 1}`}
		/>
	);
}

export default SFCarousel;
